"use client";

import { SessionProvider } from "next-auth/react"

import React from 'react'

/** Habilita o uso da sessão do usuário com o `next-auth` para a aplicação. */
const SessionWrapper = ({ children }: { children: React.ReactNode }) => {
    return (
        <SessionProvider>{children}</SessionProvider>
    )
}

export default SessionWrapper